import { Box, Button, Grid, Typography } from "@mui/material";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { useNavigate } from "react-router-dom";
import { useSuperAdminSingleSuborg } from "../../context/SuperAdmin/SingleSuborgContext";
import { Spinner } from "../../components/Loading/Spinner";
import HeadersSuborgTable from "../../components/Table/Suborg/HeadersSuborgTable";
import SingleSuborgTable from "../../components/Table/Suborg/SingleSuborgTable";
import AddUserSuborgModal from "../../components/Table/Suborg/AddUserSuborgModal";
import DeleteUserSuborgModal from "../../components/Table/Suborg/DeleteUserSuborgModal";

const SingleSuborgPage = () => {
  const navigate = useNavigate();
  const { isLoadingUsers, suborg } = useSuperAdminSingleSuborg();

  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
        color: "#005559",
      }}
    >
      {/* Boton para volver */}
      <Grid item>
        <Button onClick={() => navigate(-1)} sx={{ color: "#336B87" }}>
          <ArrowBackOutlinedIcon />
          Volver
        </Button>
      </Grid>

      {isLoadingUsers ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <>
          {/* Título */}
          <Grid item>
            <Typography
              variant={"h4"}
              sx={{ color: "#005559", fontSize: "30px" }}
            >
              <b>Suborganización</b> | {suborg?.suborganizacion}
            </Typography>
          </Grid>

          {/* Linea divisoria */}
          <Grid item>
            <Box
              sx={{ height: "1px", width: 1, border: "1px solid #005559" }}
            ></Box>
          </Grid>

          {/* Agregar o eliminar usuarios */}
          <Grid item>
            <HeadersSuborgTable />
          </Grid>

          {/* Tabla de usuarios suscritos */}
          <Grid item>
            <SingleSuborgTable />
          </Grid>

          {/* Modal para agregar usuarios a la suborganización */}
          <Grid item>
            <AddUserSuborgModal />
          </Grid>

          {/* Modal para confirmar eliminar usuarios de la suborganización */}
          <Grid item>
            <DeleteUserSuborgModal />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default SingleSuborgPage;
